import {Button, ToolbarItem} from '@patternfly/react-core';

export function ToolbarButton(props: ToolbarButtonProps) {
  return (
    <ToolbarItem>
      <Button
        id={props.id}
        data-testid={props.id || 'toolbar-button'}
        variant="primary"
        onClick={() => props.setModalOpen(true)}
        isDisabled={props.isDisabled}
      >
        {props.buttonValue}
      </Button>
      {props.isModalOpen ? props.Modal : null}{' '}
    </ToolbarItem>
  );
}

type ToolbarButtonProps = {
  id: string;
  buttonValue: string;
  Modal: object;
  isModalOpen: boolean;
  setModalOpen: (open) => void;
  isDisabled?: boolean;
};
